//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Glide from '@glidejs/glide';
import { SfButton } from '@storefront-ui/vue';
import { defineComponent } from '@nuxtjs/composition-api';
import useWindowResize from '~/hooks/useResizeWindow.js';

export default defineComponent({
  name: 'SfGallery',
  components: {
    SfButton
  },
  props: {
    content: {
      type: Array,
      default: () => []
    },
    imageWidth: {
      type: Number,
      default: null
    },
    imageHeight: {
      type: Number,
      default: null
    },
    thumbWidth: {
      type: Number,
      default: null
    },
    thumbHeight: {
      type: Number,
      default: null
    },
    current: {
      type: Number,
      default: 1
    },
    sliderOptions: {
      type: Object,
      default() {
        return {
          type: 'slider',
          autoplay: false,
          rewind: false,
          gap: 0
        };
      }
    },
    imageTag: {
      type: String,
      default: 'atoms-image-or-fallback'
    },
    thumbImageTag: {
      type: String,
      default: 'atoms-image-or-fallback'
    },
    mainSizes: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      initGlide: false,
      positionStatic: {},
      eventHover: {},
      glide: null,
      activeIndex: this.current - 1,
      style: '',
      pictureSelected: this.content[0] || {
        type: '',
        alt: '',
        zoom: '',
        big: {
          url: ''
        },
        desktop: '',
        placeholder: ''
      },
      iframeOptions:
        'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; allowfullscreen',
      carouselLoaded: false,
      activeMobileVideoIndex: null
    };
  },
  computed: {
    mapPictures() {
      // map content to handle picture tags with SfImage
      return this.content.map(({ desktop, big }) => ({
        mobile: desktop,
        desktop: big
      }));
    },
    updatedSliderOptions() {
      return { ...this.sliderOptions, startAt: this.activeIndex };
    }
  },
  mounted() {
    // handle slider with swipe and transitions with Glide.js
    // https://glidejs.com/docs/
    if (this.content.length < 1) return;
    const glide = new Glide(this.$refs.glide, this.updatedSliderOptions);
    glide.on('run.before', () => {
      if (this.isDesktop) {
        this.stopVideo(glide.index);
      }
    });
    glide.mount();
    this.glide = glide;
    this.initGlide = true;

    this.glide.on(['run.after'], () => {
      this.$emit('click:go', this.glide.index + 1);
      this.activeIndex = this.glide.index;
    });
  },
  beforeDestroy() {
    if (this.glide) {
      this.glide.destroy();
    }
  },
  methods: {
    getVideoUrl(url, autoplay = false) {
      const params = ['playsinline=1'];

      if (autoplay) {
        params.unshift('autoplay=1');
      }

      return `${url}${url.includes('?') ? '&' : '?'}${params.join('&')}`;
    },
    stopVideo(index) {
      if (this.content[index].type === 'image') return;

      const desktopVideoRef = this.$refs[`desktop-video-${index}`];
      if (desktopVideoRef?.[0]) {
        desktopVideoRef[0].src = this.getVideoUrl(
          this.content[index].desktop.url
        );
      }

      if (this.activeMobileVideoIndex === index) {
        this.activeMobileVideoIndex = null;
      }
    },
    openInlineVideo(index) {
      this.activeMobileVideoIndex = index;
    },
    go(index) {
      this.pictureSelected = this.content[index];
      if (!this.glide) return;

      if (
        this.activeMobileVideoIndex !== null &&
        this.activeMobileVideoIndex !== index
      ) {
        this.activeMobileVideoIndex = null;
      }

      this.activeIndex = index;

      /**
       * Event for current image change (`v-model`)
       * @type {Event}
       */
      this.$emit('click', index + 1);
      if (this.glide) {
        this.glide.go(`=${index}`);
      }
    }
  },
  setup() {
    const { isDesktop } = useWindowResize();

    return {
      isDesktop
    };
  }
});
